/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ui-calendar .visibility-hidden{visibility:hidden}ui-calendar mat-multi-year-view .mat-calendar-body-cell-content:not(.populated),ui-calendar mat-year-view .mat-calendar-body-cell-content:not(.populated){padding-right:25px}ui-calendar mat-multi-year-view .mat-calendar-body-cell-content .date-count-label,ui-calendar mat-year-view .mat-calendar-body-cell-content .date-count-label{width:20px;height:20px;line-height:20px;border-radius:100%;margin-left:5px}"];
export { styles as styles };
